import { Pipe, PipeTransform } from '@angular/core';
import { cellsValueFormatters } from '../formatters';

@Pipe({
    name: 'cellValueFormatter',
    standalone: false,
})
export class CellValueFormatterPipe implements PipeTransform {
  public transform(value: any, field: string): any {
    const valueFormatter = cellsValueFormatters[field];

    return valueFormatter ? valueFormatter(value) : value;
  }
}
